import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { App } from "../../../routes/Constants";
import APIVariables from "../../../services/api-variables";
import LocalStorage from "../../../shared/localStorage";
import Loader from "../../common/Loader/Loader";

// INTERN COMPONENTS
import { ViewPatientsBox, ReferAPatient, StatsCards } from "./components";
import { handleCatch } from "../../../shared/helpers";
import useRoles from "../../../hooks/useRoles";
import Axios from "../../../services/Axios";
import ReleaseNotesModal from "../../common/ReleaseNotesModal/ReleaseNotesModal";
import GuideButtons from "../../authentication/guideButtons";

const Dashboard = () => {
  const navigate = useNavigate();

  const [patientsStatistics, setPatientsStatistics] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [displayExistReleaseNotes, setDisplayExistReleaseNotes] =
    useState(false);
  const {
    isPrescriber,
    isPharmacy,
    isConnectedNurse,
    isHomecare,
    isOutpatient,
  } = useRoles();

  useEffect(() => {
    getStatistics();

    displayExistReleaseNotesInitial();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const displayExistReleaseNotesInitial = () => {
    const existReleaseNotes = localStorage.getItem(
      LocalStorage.ARE_NEW_RELEASE_NOTES
    );

    if (existReleaseNotes) {
      setDisplayExistReleaseNotes(JSON.parse(existReleaseNotes));
    }
  };

  const getStatistics = async () => {
    const res = await Axios.get(APIVariables.PATIENT_STATISTICS).catch(
      (error) => {
        handleCatch(error);
      }
    );

    if (res?.status === 200) {
      setIsLoading(false);
      setPatientsStatistics(res.data);
    }
  };

  const quitModalExistNotes = async (event) => {
    if (event.key === "Escape") {
      return;
    }
    const res = await Axios.get(APIVariables.RELEASE_NOTES_READ).catch(
      (error) => {
        handleCatch(error);
      }
    );

    if (res?.status === 200) {
      setDisplayExistReleaseNotes(false);
      localStorage.removeItem(LocalStorage.ARE_NEW_RELEASE_NOTES);
    }
  };
  if (isLoading) return <Loader />;

  const statsCards = [
    {
      key: "All Patients",
      title: "All Patients",
      value: patientsStatistics?.all_patients,
      details: "View a list of all patients that have been prescribed",
      onClick: () => navigate(App.VIEW_PATIENTS),
    },
    {
      key: "Active Patients",
      title: "Active Patients",
      value: patientsStatistics?.active_patients,
      details: "View a list of all currently prescribed patients",
      onClick: () =>
        navigate({
          pathname: "/view-patients",
          search:
            isOutpatient || isHomecare
              ? "status=approved-paf"
              : "?status=submitted",
        }),
    },
    {
      key: "Overdue PAF",
      title: "Overdue PAF",
      value: patientsStatistics?.overdue_paf,
      details: "View a list of all PAF's that are overdue",
      onClick: () =>
        navigate({
          pathname: "/view-patients",
          search: "?status=overdue-paf",
        }),
    },
    {
      key: "Rejected PAF",
      title: isOutpatient || isHomecare ? "Dispensed PAF" : "Rejected PAF",
      value:
        isOutpatient || isHomecare
          ? patientsStatistics?.dispensed_paf
          : patientsStatistics?.rejected_paf,
      details:
        isOutpatient || isHomecare
          ? "View a list of all scripts that have been dispensed"
          : "View a list of all scripts that have been rejected",
      onClick: () =>
        navigate({
          pathname: "/view-patients",
          search:
            isOutpatient || isHomecare
              ? "?status=dispensed-paf"
              : "?status=rejected-paf",
        }),
    },
  ];

  return (
    <div
      className="min-h-screen w-full overflow-y-auto bg-[#F8F8F8] px-3 pt-12"
      data-testid="dashboard-page"
    >
      <StatsCards
        cards={statsCards}
        testIdPrefix="dashboard"
        className={
          "mx-auto " + (isPrescriber ? "max-w-325" : "max-w-300")
        }
      />
      <div className="mx-auto max-w-300" data-testid="dashboard-actions">
          {!isPharmacy && !isConnectedNurse && !isHomecare && !isOutpatient ? (
            <div
              className="mb-12 mt-16 flex flex-col items-stretch gap-4 md:flex-row md:gap-0"
              data-testid="dashboard-actions-row"
            >
              <div className="flex w-full justify-center md:w-1/2 md:justify-end md:pr-2.5">
                <ReferAPatient />
              </div>
              <div className="flex w-full justify-center md:w-1/2 md:justify-start md:pl-2.5">
                <ViewPatientsBox />
              </div>
            </div>
          ) : (
            <div
              className="mb-8 mt-8 flex flex-wrap items-stretch justify-center gap-5"
              data-testid="dashboard-actions-row"
            >
              <ViewPatientsBox />
            </div>
          )}
      </div>
      {displayExistReleaseNotes && (
        <ReleaseNotesModal
          displayExistReleaseNotes={displayExistReleaseNotes}
          quitModalExistNotes={quitModalExistNotes}
        />
      )}
      <GuideButtons />
    </div>
  );
};
export default Dashboard;
